import './styles/base.css';
import './styles/components.css';
import './styles/screens.css';
import './styles/session.css';
import './styles/chrome.css';
import './styles/live.css';
import './styles/choreography.css';
import './styles/group.css';
import './styles/map.css';

import { watchForInstallPrompt } from './lib/install';
import { pruneMemberships } from './lib/membership';
import { attachRouter } from './lib/navigate';
import { registerServiceWorker } from './lib/pwa';
import { Router } from './lib/router';
import { createView } from './views/create';
import { feedbackView } from './views/feedback';
import { groupView } from './views/group';
import { landingView } from './views/landing';
import { notFoundView } from './views/not-found';
import { placesView, placeView, pinGuideView } from './views/places';
import { sessionView } from './views/session';
import { arrivalView } from './views/solo';

const container = document.querySelector<HTMLElement>('#app');
if (!container) throw new Error('#app container is missing from the document.');

// Nothing about a finished session should linger on the device.
pruneMemberships();

// The install event fires early and only once, so it has to be caught before anything else.
// Nothing is *shown* until a session has actually succeeded.
watchForInstallPrompt();

const router = new Router(container)
  .route('/', landingView)
  .route('/new', createView)
  .route('/group', groupView)
  .route('/s/:code', sessionView)
  // One picker, three fates. `/pin` is the list of the ones already kept, `/pin/:id` walks back
  // to one, and `/go/new` is the old name for choosing a point to send — kept because links to
  // it exist in the wild, and it lands on the same screen with the same fate preselected.
  .route('/place', placeView)
  .route('/pin', placesView)
  .route('/pin/:id', pinGuideView)
  .route('/go', arrivalView)
  .route('/go/new', placeView)
  .route('/feedback', feedbackView)
  .notFound(notFoundView);

attachRouter(router);
router.start();

registerServiceWorker();
